__turbopack_context__.v({
  "button": "QVcbYq_button",
  "spinner": "QVcbYq_spinner",
});
